// import Image from "next/image";
// import styles from "../page.module.css";
import Header from "../components/Header";

export default function BlogPage() {
  return (
    <div className="blog_page_wrapper">
      <Header />
      <div className="banner">
        <div style={{ width: "100%", height: "700px", position: "relative" }}>
            <img src="/blog_view.jpg" alt="" />
          {/* <Image
            src="/blog_view.jpg" // or your URL
            alt="Sample"
            fill // This makes the image fill the parent container
            style={{ objectFit: "cover" }} // Optional: cover, contain, etc.
            priority // Optional: preload image
          /> */}
        </div>
      </div>
      <div className="blog_content_wrapper">
        <h1>
          Look deep into nature, and then you will understand everything better.
        </h1>

        <p>Dear Future Human,</p>
        <p>
          I often ask people I engage with to share what is present for
          them—what they are feeling—before we dive into a deep and meaningful
          conversation or task.
        </p>
        <p>
          Connecting to our feelings helps ground us in the moment and informs
          us of what we are bringing into that moment. I have the impulse to
          share with you my emotional state at this moment. I am feeling
          energized, conflicted, and a little anxious as I am connecting to
          where I need to begin. There’s always a bit of a struggle before I can
          bring myself to begin writing.
        </p>
        <p>
          I have come to appreciate that much of the conflict and chaos we
          experience stem from our disconnection from nature. Modern humans have
          forgotten that we are not apart from Nature. We are Nature—an
          extension of its breath, its rhythms, its unbreakable will to create
          and sustain life. The trees are my lungs. If they didn’t breathe, I
          couldn’t breathe—and if I stopped breathing, they would suffer too. We
          are not separate beings; we are inside each other. My inhalation is
          their exhalation. Their respiration, the miracle of photosynthesis,
          becomes the oxygen that fills my chest. We share a quiet exchange of
          breath that connects our lives in a deep, invisible way. Earth is your
          body. This is not just a metaphor—it’s true. Your body is made from
          its minerals, its waters, its decaying leaves, and infinite sunlight.
          Just like the earth, our bodies go through cycles—leaves fall and
          become soil, rain turns into rivers, and death gives way to new life.
          We compost and seed, stardust and clay. We live on a planet designed
          to sustain life—a planet that knows how to heal itself.1
        </p>
        <p>
          In our striving to master the world, we mistook our tools for wisdom.
          We built cities and machines and digital realms, and in the process,
          we exiled ourselves from the living fabric that made us. Over time, we
          have become dis-membered and dis-connected, severing the intrinsic
          relationship we had with the natural world. In our blind arrogance, we
          lost our sense-abilities, our capacity to appreciate the intricate
          interdependent ecosystem of which we are a part. To reclaim this
          connection, we must re-collect our true nature and re-member that we
          are living organisms, governed by the same creative intelligence that
          has shaped life on earth for billions of years.
        </p>
        <p>
          What follows is a remembering. A weaving back together of threads we
          have allowed to fray: the wisdom of the Earth, the intelligence of our
          bodies, and the deeper evolutionary dance we are meant to be a part
          of. If you are to find your way forward, it will not be through
          domination, but through reconnection—to Nature, to each other, and to
          the ancient, living intelligence that still stirs quietly within you.
        </p>
        <p>
          {` We are part of 4.5 billion years of evolutionary wisdom, and Nature’s
          fundamental directive has always been to "create conditions conducive
          for life.”2 This inherent will for life exists not only in the broader
          ecosystem, but also within us—woven into our biology, behaviors, and
          instincts, beyond our layers of cultural conditioning. When we
          recognize and align with this deep, universal intelligence, we reclaim
          our place as an integral part of Nature’s ongoing evolution.`}
        </p>
      </div>
    </div>
  );
}
